// FRZA through FRZH (and any future FRZ*) exist only to mirror SAP storage
// locations. They are legitimate SAP data, but they are not sites anyone reports
// on, and their names shadow the real ones -- FRZA is "GPS AULNOIS" while FRA1 is
// "GPS AULNOIS A/V" -- so users kept picking the wrong one and getting errors.
// Hide them from every plant picker, while keeping them resolvable by id so
// existing records that reference them still render a real name.
export const HIDDEN_PLANT_ID_PREFIXES = ['FRZ']

// Individual ids to hide, for plants that do not share a prefix.
export const HIDDEN_PLANT_IDS = []

export const CONSULTING_PLANT_KEY = 'consultingPlant'

export function isSelectablePlant (plant) {
  const id = plant && plant.id != null ? String(plant.id) : ''
  if (HIDDEN_PLANT_IDS.includes(id)) {
    return false
  }
  return !HIDDEN_PLANT_ID_PREFIXES.some(prefix => id.startsWith(prefix))
}

export function filterSelectablePlants (plants) {
  return Array.isArray(plants) ? plants.filter(isSelectablePlant) : []
}

// The plant selection is shared between tabs through sessionStorage, so a hidden
// plant picked before it was hidden would otherwise keep feeding every picker.
export function restoreConsultingPlant () {
  let stored = null
  try {
    stored = JSON.parse(sessionStorage.getItem(CONSULTING_PLANT_KEY))
  } catch (error) {
    return null
  }
  return stored && isSelectablePlant(stored) ? stored : null
}
